'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Vas = require('../Vas');

var _Vas2 = _interopRequireDefault(_Vas);

require('../css/ControlBase.css');

var _MessageBox = require('./MessageBox');

var _MessageBox2 = _interopRequireDefault(_MessageBox);

var _utilsLib = require('utils-lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import T from 'i18n-react';
//var data = require('../../public/elements/i18n/de.json');
//var data = require('./i18n/de.json');
//T.setTexts(data);

/*
Pflichtproperties:
AppURL={Vas.ApplicationUrl} 
me={this} Id={"name"} ref={"name"} name="name"
IsRequired={true/false} Editable={true/false}  
Label={ Vas.Resources.Labels["Name"]} 
TitleMessageNotValidCharacter={Vas.Resources.Labels["Note"]} 
MessageNotValidCharacter={Vas.Resources.Labels["NotValidCharacter"]} 

optional:
Modus={"Name"} Tooltip={Vas.Resources.Tooltips["Name"]} OnChange={()=>{ this.setState({ Name:  $("#name").val() })}}
Autocomplete={false/true}=>"off"/"on"
*/
var Textfield = function (_Component) {
    _inherits(Textfield, _Component);

    function Textfield(props) {
        _classCallCheck(this, Textfield);

        var _this = _possibleConstructorReturn(this, (Textfield.__proto__ || Object.getPrototypeOf(Textfield)).call(this, props));

        _this.state = {};
        _this.state.isrequired = _this.props.IsRequired;
        _this.state.required = true;
        _this.state.editable = _this.props.Editable;
        _this.state.Label = _this.props.Label;
        _this.state.Value = _this.props.Value;
        _this.state.Placeholder = _this.props.Placeholder;
        _this.state.OnKeyDown = _this.props.OnKeyDown;
        _this.state.OnChange = _this.props.OnChange;
        _this.state.autocomplete = _this.props.Autocomplete;
        _this.state.TextTooltip = _this.props.TextTooltip;
        return _this;
    }

    _createClass(Textfield, [{
        key: 'checkValue',
        value: function checkValue(me) {
            var filled = true;
            if (me.props.Modus === "Name") {
                if ((0, _jquery2.default)("#" + me.props.Id).val().length > 0) {
                    if (_utilsLib.CheckValues.CheckName((0, _jquery2.default)("#" + me.props.Id).val()) === false) {
                        filled = false;
                        (0, _jquery2.default)("#" + me.props.Id).val((0, _jquery2.default)("#" + me.props.Id).val().substr(0, (0, _jquery2.default)("#" + me.props.Id).val().length - 1));
                        me.ShowMessageName(me);
                    }
                }
            } else if (me.props.Modus === "Number") {
                if ((0, _jquery2.default)("#" + me.props.Id).val().length > 0) {
                    if (_utilsLib.CheckValues.CheckNumber((0, _jquery2.default)("#" + me.props.Id).val()) === false) {
                        filled = false;
                        (0, _jquery2.default)("#" + me.props.Id).val((0, _jquery2.default)("#" + me.props.Id).val().substr(0, (0, _jquery2.default)("#" + me.props.Id).val().length - 1));
                        me.ShowMessageNumber(me);
                    }
                }
            } else if (me.props.Modus === "Char") {
                if ((0, _jquery2.default)("#" + me.props.Id).val().length > 0) {
                    if (_utilsLib.CheckValues.CheckChar((0, _jquery2.default)("#" + me.props.Id).val()) === false) {
                        filled = false;
                        (0, _jquery2.default)("#" + me.props.Id).val((0, _jquery2.default)("#" + me.props.Id).val().substr(0, (0, _jquery2.default)("#" + me.props.Id).val().length - 1));
                        me.ShowMessageChar(me);
                    }
                }
            } else if (me.props.Modus === "TelNumber") {
                if ((0, _jquery2.default)("#" + me.props.Id).val().length > 0) {
                    if (_utilsLib.CheckValues.CheckTelNumber((0, _jquery2.default)("#" + me.props.Id).val()) === false) {
                        filled = false;
                        (0, _jquery2.default)("#" + me.props.Id).val((0, _jquery2.default)("#" + me.props.Id).val().substr(0, (0, _jquery2.default)("#" + me.props.Id).val().length - 1));
                        me.ShowMessageTelNumber(me);
                    }
                }
            } else if (me.props.Modus === "GradeLevel") {
                if ((0, _jquery2.default)("#" + me.props.Id).val().length > 0) {
                    if (_utilsLib.CheckValues.CheckGradeLevel((0, _jquery2.default)("#" + me.props.Id).val()) === false) {
                        filled = false;
                        (0, _jquery2.default)("#" + me.props.Id).val((0, _jquery2.default)("#" + me.props.Id).val().substr(0, (0, _jquery2.default)("#" + me.props.Id).val().length - 1));
                        me.ShowMessageGradeLevel(me);
                    }
                }
            } else if (me.props.Modus === "Class") {
                if ((0, _jquery2.default)("#" + me.props.Id).val().length > 0) {
                    if (_utilsLib.CheckValues.CheckClass((0, _jquery2.default)("#" + me.props.Id).val()) === false) {
                        filled = false;
                        (0, _jquery2.default)("#" + me.props.Id).val((0, _jquery2.default)("#" + me.props.Id).val().substr(0, (0, _jquery2.default)("#" + me.props.Id).val().length - 1));
                        me.ShowMessageClass(me);
                    }
                }
            }

            return filled;
        }
    }, {
        key: 'tab',
        value: function tab(event, me) {
            if (event) {
                if (event.keyCode === 13 || event.keyCode === 9) {
                    (0, _jquery2.default)("#" + me.props.Id).val(_utilsLib.XssFilter.getText((0, _jquery2.default)("#" + me.props.Id).val()));
                    me.checkFields();

                    var filled = true;

                    if (me.state.isrequired) {
                        if ((0, _jquery2.default)("#" + me.props.Id).val().length === 0) {
                            filled = false;
                        } else {
                            filled = true;
                        }
                    }
                    if (filled === true) {
                        // filled = this.checkValue(me);
                    }

                    var docs = document.querySelectorAll('div.ss-selected-option,input,button,select');
                    var maxId = docs.length;
                    var aktive = document.activeElement.id;
                    var i = void 0;

                    for (i = 0; i <= maxId - 1; i++) {

                        if (docs[i].id === aktive) {
                            if (i === maxId - 1) {
                                docs[i].blur();
                                break;
                            } else {
                                if (event.shiftKey && event.keyCode === 9) {
                                    for (var j = i - 1; j >= 0; j--) {
                                        if (!docs[j].readOnly) {
                                            docs[j].focus();
                                            break;
                                        } else if (docs[j].className === "ss-selected-option") {
                                            var _event = new Event("click");
                                            docs[j].dispatchEvent(_event);
                                            break;
                                        }
                                    }
                                } else {
                                    for (var _j = i + 1; _j <= maxId - 1; _j++) {
                                        if (!docs[_j].readOnly) {
                                            docs[_j].focus();
                                            break;
                                        } else if (docs[_j].className === "ss-selected-option") {
                                            var _event2 = new Event("click");
                                            docs[_j].dispatchEvent(_event2);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    me.setState({ required: filled });
                } else if (event.keyCode === undefined) {
                    (0, _jquery2.default)("#" + me.props.Id).val(_utilsLib.XssFilter.getText((0, _jquery2.default)("#" + me.props.Id).val()));
                    me.checkFields();
                    var _filled = true;
                    if (me.state.isrequired) {
                        if ((0, _jquery2.default)("#" + me.props.Id).val().length === 0) {
                            _filled = false;
                        } else {
                            _filled = true;
                        }
                    }

                    //filled = this.checkValue(me);
                    me.setState({ required: _filled });
                } else if (event.keyCode === 8 || event.keyCode === 46) {
                    if ((0, _jquery2.default)("#" + me.props.Id).val().length === 1) {
                        me.setState({ Placeholder: null });
                    }
                }
            }
        }
    }, {
        key: 'checkFields',
        value: function checkFields() {
            if (this.props.me) {
                var docs = document.querySelectorAll('select,input');
                var docRefs = this.props.me.refs;
                _utilsLib.CheckValues.checkAllFields(docs, docRefs, this.props.Id);
            }
        }
    }, {
        key: 'ShowMessageName',
        value: function ShowMessageName(me) {
            var title = me.props.TitleMessageNotValidCharacter ? me.props.TitleMessageNotValidCharacter : _Vas2.default.getText("Titles", "Note");
            var text = me.props.MessageNotValidCharacter ? me.props.MessageNotValidCharacter : _Vas2.default.getText('Labels', 'NotValidCharacter');
            if (title && text) {
                _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                    AppURL: me.props.AppURL,
                    Title: title,
                    Message: text,
                    Field: me.props.Id }), document.getElementById('messageContainer'));
            }
        }
    }, {
        key: 'ShowMessageNumber',
        value: function ShowMessageNumber(me) {
            var title = me.props.TitleMessageNotValidNumber ? me.props.TitleMessageNotValidNumber : _Vas2.default.getText("Titles", "Note");
            var text = me.props.MessageNotValidNumber ? me.props.MessageNotValidNumber : _Vas2.default.getText('Labels', 'NotValidNumber');
            if (title && text) {
                _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                    AppURL: me.props.AppURL,
                    Title: title,
                    Message: text,
                    Field: me.props.Id }), document.getElementById('messageContainer'));
            }
        }
    }, {
        key: 'ShowMessageTelNumber',
        value: function ShowMessageTelNumber(me) {
            var title = me.props.TitleMessageNotValidNumber ? me.props.TitleMessageNotValidNumber : _Vas2.default.getText("Titles", "Note");
            var text = me.props.MessageNotValidNumber ? me.props.MessageNotValidNumber : _Vas2.default.getText('Labels', 'NotValidTelNumber');
            if (title && text) {
                _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                    AppURL: me.props.AppURL,
                    Title: title,
                    Message: text,
                    Field: me.props.Id }), document.getElementById('messageContainer'));
            }
        }
    }, {
        key: 'ShowMessageChar',
        value: function ShowMessageChar(me) {
            var title = me.props.TitleMessageNotValidChar ? me.props.TitleMessageNotValidChar : _Vas2.default.getText("Titles", "Note");
            var text = me.props.MessageNotValidChar ? me.props.MessageNotValidChar : _Vas2.default.getText('Labels', 'NotValidChar');
            if (title && text) {
                _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                    AppURL: me.props.AppURL,
                    Title: title,
                    Message: text,
                    Field: me.props.Id }), document.getElementById('messageContainer'));
            }
        }
    }, {
        key: 'ShowMessageGradeLevel',
        value: function ShowMessageGradeLevel(me) {
            var title = me.props.TitleMessageNotValidNumber ? me.props.TitleMessageNotValidNumber : _Vas2.default.getText("Titles", "Note");
            var text = me.props.MessageNotValidNumber ? me.props.MessageNotValidNumber : _Vas2.default.getText('Labels', 'NotValidGradeLevel');
            if (title && text) {
                _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                    AppURL: me.props.AppURL,
                    Title: title,
                    Message: text,
                    Field: me.props.Id }), document.getElementById('messageContainer'));
            }
        }
    }, {
        key: 'ShowMessageClass',
        value: function ShowMessageClass(me) {
            var title = me.props.TitleMessageNotValidChar ? me.props.TitleMessageNotValidChar : _Vas2.default.getText("Titles", "Note");
            var text = me.props.MessageNotValidChar ? me.props.MessageNotValidChar : _Vas2.default.getText('Labels', 'NotValidClass');
            if (title && text) {
                _reactDom2.default.render(_react2.default.createElement(_MessageBox2.default, {
                    AppURL: me.props.AppURL,
                    Title: title,
                    Message: text,
                    Field: me.props.Id }), document.getElementById('messageContainer'));
            }
        }
    }, {
        key: 'focus',
        value: function focus(id) {
            (0, _jquery2.default)("#" + id).select();
            if (this.state.Placeholder) {
                if (this.state.Placeholder.length > 0 && (0, _jquery2.default)("#" + id).val().length === 0) {
                    (0, _jquery2.default)("#" + id).val(this.state.Placeholder);
                }
            }

            var elements = document.getElementsByClassName('focusedCheckBox');
            var i = void 0;

            for (i = 0; i < elements.length; i++) {
                elements[i].classList.remove('focusedCheckBox');
            }

            elements = document.getElementsByClassName('extendedButton');
            i = void 0;

            for (i = 0; i < elements.length; i++) {
                elements[i].classList.remove('focusedButton');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var Tooltip = "";
            var ValidateIcon = "";
            var FieldNotFilled = "";

            var TextTooltip = "";
            if (this.props.Tooltip && this.props.Tooltip !== "") {
                Tooltip = _react2.default.createElement(
                    'span',
                    { id: this.props.Id + "Tooltip" },
                    this.props.Tooltip
                );
            }

            if (this.state.TextTooltip && this.state.TextTooltip !== "") {
                TextTooltip = _react2.default.createElement(
                    'span',
                    { id: this.props.Id + "TextTooltip" },
                    this.state.TextTooltip
                );
            }

            if (this.props.FieldNotFilledHint && this.props.FieldNotFilledHint !== "") {
                FieldNotFilled = _react2.default.createElement(
                    'div',
                    { id: this.props.Id + "FieldNotFilled", className: "fieldNotFilled" },
                    this.props.FieldNotFilledHint
                );
            }

            if (this.props.ValidateField) {
                var iconClass = "ok";
                if (!this.props.Valid) {
                    iconClass = "notOk";
                }

                ValidateIcon = _react2.default.createElement('div', { className: iconClass });
            }

            var controlClassName = "textfield";

            var Style = null;

            if (this.props.Width) {
                Style = { width: this.props.Width, float: this.props.Float };
            }

            if (this.props.BorderBottom) {
                Style = { width: this.props.Width, float: this.props.Float, borderBottom: this.props.BorderBottom };
            }

            var StyleLabel = Style;
            if (this.props.LabelHeight) {
                StyleLabel = { width: this.props.Width, float: this.props.Float, height: this.props.LabelHeight };
            }

            var readOnly = false;
            var isTextFieldFilled = true;

            if (this.state.editable) {

                if (this.state.isrequired) {
                    if (this.state.required) {
                        controlClassName = "textfield";
                        readOnly = false;
                    } else {
                        controlClassName = "textfieldNotFilled";
                        readOnly = false;
                        isTextFieldFilled = false;
                    }
                } else {
                    controlClassName = "textfield";
                    readOnly = false;
                }
            } else {
                controlClassName = "textfieldDisabled";
                readOnly = true;
            }
            var type = "text";

            if (this.props.Type) {
                type = this.props.Type;
            }

            var autocom = "on";
            if (this.state.autocomplete) {
                if (this.state.autocomplete === false) {
                    autocom = "off";
                }
            }

            var isTextFieldFilledStyle = { visibility: 'hidden' };

            if (!isTextFieldFilled) {
                isTextFieldFilledStyle = { visibility: 'visible' };
            }

            return _react2.default.createElement(
                'div',
                { style: Style, className: "tf" },
                _react2.default.createElement(
                    'label',
                    {
                        className: 'textfieldLabel',
                        style: StyleLabel,
                        id: this.props.Id + "Label",
                        'for': this.props.Id },
                    this.state.Label,
                    ' ',
                    Tooltip
                ),
                _react2.default.createElement(
                    'div',
                    { className: "txtField" },
                    _react2.default.createElement('input', {
                        onBlur: function onBlur(e) {
                            if (_this2.props.OnBlur) {
                                _this2.props.OnBlur();
                            }_this2.tab(e, _this2);
                        },
                        onKeyDown: function onKeyDown(e) {
                            if (e.keyCode === 9) {
                                e.preventDefault();
                            }if (_this2.state.OnKeyDown) {
                                _this2.state.OnKeyDown();
                            }_this2.tab(e, _this2);
                        },
                        onChange: function onChange() {
                            _this2.checkValue(_this2);if (_this2.state.OnChange) {
                                _this2.state.OnChange();
                            }
                        },
                        style: Style,
                        onFocus: function onFocus() {
                            _this2.focus(_this2.props.Id);
                        },
                        onInput: function onInput() {
                            if (_this2.props.onInput) {
                                _this2.props.onInput();
                            }
                        },
                        id: this.props.Id,
                        type: type,
                        className: controlClassName,
                        value: this.state.Value,
                        placeholder: this.state.Placeholder,
                        readOnly: readOnly,
                        tabIndex: this.props.Tabindex,
                        autoComplete: autocom }),
                    ValidateIcon,
                    TextTooltip,
                    ' '
                ),
                _react2.default.createElement(
                    'div',
                    { id: this.props.Id + "FieldNotFilled", style: isTextFieldFilledStyle },
                    FieldNotFilled
                )
            );
        }
    }]);

    return Textfield;
}(_react.Component);

exports.default = Textfield;